import Icon from '@ant-design/icons'

const LangZhSVG = () => (
    <svg
        t='1645596722637'
        viewBox='0 0 1070 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='2172'
        className='icon'
    >
        <path
            d='M683.52 540.16h115.2V512h-115.2v-61.44h122.88v-30.72h-158.72V640h163.84v-30.72h-128v-69.12z m240.64-64c-10.24 0-17.92 2.56-25.6 5.12s-15.36 10.24-20.48 17.92v-17.92h-35.84V640h35.84v-94.72c0-12.8 5.12-23.04 12.8-28.16s12.8-10.24 23.04-10.24c23.04 0 35.84 12.8 35.84 38.4V640h35.84v-97.28c-2.56-46.08-20.48-66.56-61.44-66.56zM197.12 366.08h92.16v87.04H197.12zM325.12 366.08h92.16v87.04h-92.16z'
            p-id='2173'
            fill='currentColor'
        ></path>
        <path
            d='M980.48 143.36H532.48l-25.6-138.24H89.6C43.52 5.12 5.12 43.52 5.12 89.6v709.12c0 46.08 38.4 84.48 84.48 84.48h378.88l-30.72 138.24h542.72c46.08 0 84.48-38.4 84.48-84.48V227.84c0-46.08-38.4-84.48-84.48-84.48zM453.12 504.32h-35.84v-20.48h-92.16v115.2h-35.84v-115.2H197.12v20.48H163.84V332.8h125.44v-61.44h35.84V332.8h128v171.52zM1024 934.4c0 23.04-17.92 40.96-40.96 40.96H491.52l20.48-94.72h156.16L581.12 384v2.56l-2.56-20.48-33.28-181.76h437.76c23.04 0 40.96 20.48 40.96 43.52v706.56z'
            p-id='2174'
            fill='currentColor'
        ></path>
    </svg>
)

export const LangZhIcon = props => <Icon component={LangZhSVG} {...props} />
